import 'core-js/modules/es.object.assign.js';
import { useContainer } from '@hub-la/fe-container';
import { HttpClient } from '@hub-la/fe-core-http-client';
import { useMutation, useQueryClient } from 'react-query';
import { QueryKey } from '../../domain/enums/query-keys.js';
import { PutComment } from '../../usecases/put-comment.js';
import { useDiscussion } from '../providers/discussion.js';

const usePutComment = ({
  onSuccess,
  isReply,
  parentCommentId
}) => {
  const container = useContainer();
  const queryClient = useQueryClient();
  const discussion = useDiscussion();
  return useMutation([QueryKey.putComment], input => new PutComment(container.get(HttpClient)).execute(Object.assign(Object.assign({}, input), {
    postId: discussion.metadata.postId
  })), {
    retry: false,
    onSuccess: (_, input) => {
      var _a;
      if (onSuccess) {
        onSuccess();
      }
      if (isReply) {
        queryClient.setQueryData([QueryKey.getCommentReplies, parentCommentId], commentsRepliesData => {
          var _a;
          if (!commentsRepliesData) {
            return {
              pages: [],
              pageParams: []
            };
          }
          commentsRepliesData.pages = (_a = commentsRepliesData === null || commentsRepliesData === void 0 ? void 0 : commentsRepliesData.pages) === null || _a === void 0 ? void 0 : _a.map(page => {
            var _a;
            const oldItems = (_a = page.items) !== null && _a !== void 0 ? _a : [];
            const updatedItems = oldItems.map(comment => {
              if (comment.id === input.commentId) {
                return Object.assign(Object.assign({}, comment), {
                  message: input.message,
                  wasEdited: true,
                  updatedAt: new Date().toISOString()
                });
              }
              return comment;
            });
            return Object.assign(Object.assign({}, page), {
              items: updatedItems
            });
          });
          return commentsRepliesData;
        });
        return;
      }
      queryClient.setQueryData([QueryKey.getComments, (_a = discussion === null || discussion === void 0 ? void 0 : discussion.metadata) === null || _a === void 0 ? void 0 : _a.postId], commentsData => {
        if (!commentsData) {
          return {
            pages: [],
            pageParams: []
          };
        }
        commentsData.pages = commentsData === null || commentsData === void 0 ? void 0 : commentsData.pages.map(page => {
          var _a;
          const oldItems = (_a = page.items) !== null && _a !== void 0 ? _a : [];
          const updatedItems = oldItems === null || oldItems === void 0 ? void 0 : oldItems.map(comment => {
            if (comment.id === input.commentId) {
              return Object.assign(Object.assign({}, comment), {
                message: input.message
              });
            }
            return comment;
          });
          return Object.assign(Object.assign({}, page), {
            items: updatedItems
          });
        });
        return commentsData;
      });
    }
  });
};

export { usePutComment };
